import React from 'react'

const Leaf = (
  {
    color = '#FFF'
  }
) => {
  return (
    <svg viewBox="0 0 65 65">
      <path fill={color} d="M27.7,46.1c-5.3,0-9.2-1.7-9.5-1.8l-0.3-0.1l-0.2-0.3c-0.1-0.2-3.1-4.1-2.5-9.2c0.5-3.5,2.5-6.7,6.1-9.4l0,0
	c8.8-6.7,30.3-9.5,31.3-9.6l2-0.2l-0.4,2C54,18,51,34.2,41.4,41.5C36.7,45.1,31.8,46.1,27.7,46.1z M19.8,41.7
	c2,0.7,11.6,3.8,19.8-2.5c6.9-5.2,10.1-15.9,11.2-20.4c-5.6,0.9-21.1,3.6-27.8,8.7l0,0c-2.9,2.2-4.6,4.7-4.9,7.4
	C17.7,38.2,19.2,40.9,19.8,41.7z M22.2,26.4L22.2,26.4L22.2,26.4z"/>
      <rect x="8.3" y="38" transform="matrix(0.7955 -0.606 0.606 0.7955 -19.1258 22.2907)" fill={color} width="30.4" height="2.9"/>
    </svg>
  )
}

export default Leaf
